<template>
  <div :class="componentClassName">
    <section class="t-vdxb-entry__col t-vdxb-entry__col--login">
      <div class="t-vdxb-entry__login-block">
        <div class="t-vdxb-entry__login-logo">
          <div class="t-vdxb-entry__logo-coperate">
            <img src="@/images/corporatebrandmark.svg" alt="" />
          </div>
          <div class="t-vdxb-entry__logo-cotoha">
            <img src="@/images/COTOHA_VoiceDX_Basic.svg" alt="" />
          </div>
        </div>
        <div class="t-vdxb-entry__login-graphic">
          <img src="@/images/pages/vdxb-login-graphic.svg" />
        </div>
      </div>
    </section>

    <section class="t-vdxb-entry__col">
      <div class="t-vdxb-entry__form-wrapper">
        <a-vdxb-heading
          class="t-vdxb-entry__heading"
          tag="h1"
          variant="center"
          :heading="heading"
          :subheading="subHeading"
        />
        <a-vdxb-section-divider />

        <div class="t-vdxb-entry__body">
          <slot></slot>
        </div>
      </div>

      <o-global-footer class="t-vdxb-entry__footer">
        <m-link-container>
          <template v-for="(item, index) in navigationItems" :key="index">
            <li>
              <a-vdxb-button variant="text" size="small" :href="item.link">{{ item.label }}</a-vdxb-button>
            </li>
          </template>
        </m-link-container>
      </o-global-footer>
    </section>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';

import AVdxbButton from '@/components/atoms/vdxb-button';
import AVdxbHeading from '@/components/atoms/vdxb-heading';
import AVdxbSectionDivider from '@/components/atoms/vdxb-section-divider';
import MLinkContainer from '@/components/molecules/link-container';
import OGlobalFooter from '@/components/organisms/global-footer';

export default {
  name: 't-vdxb-default-entry',
  components: {
    AVdxbButton,
    AVdxbHeading,
    AVdxbSectionDivider,
    MLinkContainer,
    OGlobalFooter,
  },
  props: {
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    class: {
      type: String,
      default: '',
    },
    heading: {
      type: String,
      default: null,
    },
    subHeading: {
      type: String,
      default: null,
    },
    navigationItems: {
      type: Array,
      default: new Array(0),
    },
    activeNavId: {
      type: String,
      default: '',
    },
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-vdxb-entry');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
};
</script>
